export var ShapeType;
(function (ShapeType) {
    ShapeType[ShapeType["Unknown"] = 0] = "Unknown";
    ShapeType[ShapeType["Point"] = 1] = "Point";
    ShapeType[ShapeType["Polyline"] = 2] = "Polyline";
    ShapeType[ShapeType["Polygon"] = 3] = "Polygon";
    ShapeType[ShapeType["Circle"] = 4] = "Circle";
    ShapeType[ShapeType["Line"] = 5] = "Line";
})(ShapeType || (ShapeType = {}));
export function isClipable(value) {
    return value && value.clip !== undefined;
}
export function isShape(value) {
    return value && value.type !== undefined && ShapeType[value.type] !== undefined;
}
export function isCircle(shape) {
    if (typeof shape !== "object" || shape === null)
        return false;
    return shape.type === ShapeType.Circle;
}
export function isLine(shape) {
    if (typeof shape !== "object" || shape === null)
        return false;
    return shape.type === ShapeType.Line;
}
export function isPolyline(shape) {
    if (typeof shape !== "object" || shape === null)
        return false;
    return shape.type === ShapeType.Polyline;
}
export function isPolygon(shape) {
    if (typeof shape !== "object" || shape === null)
        return false;
    return shape.type === ShapeType.Polygon;
}
//# sourceMappingURL=geometry.shapes.interfaces.js.map